import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { toSafetyHome } from '@/lib/safetyHome';

/** 안전 관리의 옛 주소 → 안전 홈페이지. 보던 탭 그대로, 뒤로 가기에 옛 주소가 남지 않게 replace 다. */
export function SafetyHomeRedirect() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.location.replace(toSafetyHome(pathname, search));
  }, [pathname, search]);
  return null;
}
